import React, { Component } from "react";
import { CustomDialog } from "../MarkOrder.style";
import { Button, DialogTitle, DialogActions } from "@material-ui/core";

export class CancelOrderDialog extends Component {
  render() {
    let { dialogToggle, handleClose, cancelOrderHandler } = this.props;
    return (
      <CustomDialog
        open={dialogToggle}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"md"}
      >
        <DialogTitle id="alert-dialog-title">{"Cancel Order?"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => cancelOrderHandler()}
          >
            {"Cancel order"}
          </Button>
        </DialogActions>
      </CustomDialog>
    );
  }
}

export default CancelOrderDialog;
